import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { TableCell, TableRow, Typography, Tooltip, Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Info } from '@material-ui/icons';
import { DateTime } from 'luxon';
import { ContestComissionDetailsModal } from './ContestComissionDetailsModal';
import styles from './ContestComissionTableRow.styles';

const useRowStyles = makeStyles(styles);

export function ContestComissionTableRow({ data }) {
  const classes = useRowStyles();
  const [detailsModalOpen, setDetailsModalOpen] = useState(false);

  const renderCellWithTooltip = content => (
    <Tooltip title={content || ''} placement="top">
      <Typography className={classes.tableCellTextEllipsis}>{content || '-'}</Typography>
    </Tooltip>
  );

  const formatDateValue = date => {
    if (!date) {
      return '-';
    }
    try {
      const dateObj = new Date(date);
      const day = String(dateObj.getDate()).padStart(2, '0');
      const month = String(dateObj.getMonth() + 1).padStart(2, '0');
      const year = dateObj.getFullYear();
      const hours = String(dateObj.getHours()).padStart(2, '0');
      const minutes = String(dateObj.getMinutes()).padStart(2, '0');
      return `${day}/${month}/${year} ${hours}:${minutes}`;
    } catch {
      return date;
    }
  };

  const getMessagePreview = message => {
    if (!message) {
      return '-';
    }
    const maxLength = 100;
    if (message.length <= maxLength) {
      return message;
    }
    return `${message.substring(0, maxLength)}...`;
  };

  const formatReferenceMonth = referenceDate => {
    if (!referenceDate) {
      return '-';
    }
    try {
      return DateTime.fromJSDate(new Date(referenceDate)).toFormat('MM/yyyy');
    } catch {
      return '-';
    }
  };

  return (
    <>
      <TableRow>
        <TableCell className={classes.tableCell}>{formatDateValue(data?.createdAt)}</TableCell>
        <TableCell className={classes.tableCell}>{renderCellWithTooltip(data?.partnerName || '-')}</TableCell>
        <TableCell className={classes.tableCell}>{renderCellWithTooltip(data?.partnerInvoiceId)}</TableCell>
        <TableCell className={classes.tableCell}>
          {renderCellWithTooltip(formatReferenceMonth(data?.invoiceMetadata?.referenceDate))}
        </TableCell>
        <TableCell className={classes.tableCell}>
          <Tooltip title={data?.message || ''} placement="top">
            <Typography className={classes.messagePreview}>{getMessagePreview(data?.message)}</Typography>
          </Tooltip>
        </TableCell>
        <TableCell className={classes.tableCell}>
          <div className={classes.actionsCell}>
            <Button
              size="small"
              variant="outlined"
              className={classes.actionButton}
              startIcon={<Info fontSize="small" />}
              onClick={() => setDetailsModalOpen(true)}
            >
              Ver Detalhes
            </Button>
          </div>
        </TableCell>
      </TableRow>

      <ContestComissionDetailsModal open={detailsModalOpen} onClose={() => setDetailsModalOpen(false)} data={data} />
    </>
  );
}

ContestComissionTableRow.propTypes = {
  data: PropTypes.shape({
    id: PropTypes.string,
    partnerId: PropTypes.string,
    partnerName: PropTypes.string,
    partnerInvoiceId: PropTypes.string,
    message: PropTypes.string,
    createdAt: PropTypes.string,
    invoiceMetadata: PropTypes.object,
    invoiceItems: PropTypes.array,
  }).isRequired,
};
